export enum TypeNomenclature {
  Complex = 'Комплекс',
  Analysis = 'Анализ',
  Service = 'Услуга',
}
